import React, { useEffect } from 'react';

import { expVal } from '@confluence/feature-experiments';

import { useSnippetsFetchAnalytics } from '../hooks/useSnippetsFetchAnalytics.ts';
import { useSnippetsActions } from './snippetsStore.ts';

/**
 * Provider component that ensures snippets are fetched before the component tree renders.
 * The first fetch resolves site config (isSnippetSharingForSiteEnabled) inside the fetch flow and stores it.
 */
export const SnippetsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const snippetsActions = useSnippetsActions();
	useSnippetsFetchAnalytics();

	useEffect(() => {
		if (!expVal('cc_snippets', 'isEnabled', false)) {
			return;
		}
		// Fire-and-forget: the store resolves site config and fetches; deduplication and isLoading handled there
		void snippetsActions.fetchSnippets();
	}, [snippetsActions]);

	// Render children immediately - the fetch happens in the background
	return <>{children}</>;
};
